/* eslint-disable react/jsx-no-target-blank */
import {useAuth} from 'app/modules/auth';
import {FC} from 'react';
import {AsideMenuItem} from './AsideMenuItem';
import {useMyPendingCount} from 'app/modules/tickets/hooks/useMyPendingCount';
import {OPS_OVERVIEW_ENABLED} from 'app/modules/operationalOverview/overviewFlags';

type Props = {
  isMenuOpen: boolean;
};

export const AsideMenuMain: FC<Props> = ({isMenuOpen}) => {
  const {currentUser} = useAuth();
  const pendingCount = useMyPendingCount() ?? 0;

  if (currentUser?.role === 'ROLE_THIRD_PARTY_STOCK_MANAGER') {
    return (
      <AsideMenuItem
        to='/incident-deliveries/tracking'
        title='Logística reversa'
        bsTitle='Logística reversa'
        fontIcon='bi-arrow-repeat'
        className='py-2'
        isMenuOpen={isMenuOpen}
      />
    );
  }

  return (
    <>
      <AsideMenuItem
        to='/catalog/search'
        title='Pesquisa por Peças'
        bsTitle='Pesquisa'
        fontIcon='bi-search'
        className='py-2'
        isMenuOpen={isMenuOpen}
      />

      <AsideMenuItem
        to='/quotes/workspace'
        title='Torre de controle'
        bsTitle='Torre de controle'
        fontIcon='bi-file-earmark-text'
        className='py-2'
        isMenuOpen={isMenuOpen}
      />

      <AsideMenuItem
        to='/quotes/list'
        title='Listagem de cotações'
        bsTitle='Cotações'
        fontIcon='bi-card-checklist'
        className='py-2'
        isMenuOpen={isMenuOpen}
      />

      <AsideMenuItem
        to='/orders'
        title='Pedidos'
        bsTitle='Pedidos'
        fontIcon='bi-box2'
        className='py-2'
        isMenuOpen={isMenuOpen}
      />

      <AsideMenuItem
        to='/purchases/tracking'
        title='Compras'
        bsTitle='Compras'
        fontIcon='bi-cart'
        className='py-2'
        isMenuOpen={isMenuOpen}
      />

      <AsideMenuItem
        to='/tickets'
        title='Tickets'
        bsTitle='Tickets'
        fontIcon='bi-ticket-detailed'
        className='py-2'
        isMenuOpen={isMenuOpen}
        badge={pendingCount}
      />

      <AsideMenuItem
        to='/coupons/list'
        title='Cupons'
        bsTitle='Cupons'
        fontIcon='bi-tags-fill'
        className='py-2'
        isMenuOpen={isMenuOpen}
      />

      <AsideMenuItem
        to='/banner-campaigns/campaigns'
        title='Banners'
        bsTitle='Banners'
        fontIcon='bi-image-fill'
        className='py-2'
        isMenuOpen={isMenuOpen}
      />

      <AsideMenuItem
        to='/deliveries/tracking-single-express'
        title='Acompanhamento de entregas'
        bsTitle='Acompanhamento de entregas'
        fontIcon='bi-truck'
        className='py-2'
        isMenuOpen={isMenuOpen}
      />

      <AsideMenuItem
        to='/cancelled-items/list/stock-items'
        title='Cancelamentos e devoluções'
        bsTitle='Cancelamentos e devoluções'
        fontIcon='bi-x-square-fill'
        className='py-2'
        isMenuOpen={isMenuOpen}
      />

      <AsideMenuItem
        to='/incident-deliveries/tracking'
        title='Logística reversa'
        bsTitle='Logística reversa'
        fontIcon='bi-arrow-repeat'
        className='py-2'
        isMenuOpen={isMenuOpen}
      />

      <AsideMenuItem
        to='/mechanics/list'
        title='Oficinas'
        bsTitle='Oficinas'
        fontIcon='bi bi-shop-window'
        className='py-2'
        isMenuOpen={isMenuOpen}
      />

      <AsideMenuItem
        to='/providers/list'
        title='Fornecedores'
        fontIcon='bi-wrench-adjustable'
        bsTitle=' Fornecedores'
        className='py-2'
        isMenuOpen={isMenuOpen}
      />

      <AsideMenuItem
        to='/members/list'
        title='Mecanizados'
        fontIcon='bi-people'
        bsTitle=' Mecanizados'
        className='py-2'
        isMenuOpen={isMenuOpen}
      />

      <AsideMenuItem
        to='/finance/invoices'
        title='Financeiro'
        fontIcon='bi-currency-dollar'
        bsTitle=' Financeiro'
        className='py-2'
        isMenuOpen={isMenuOpen}
      />

      <AsideMenuItem
        to='/communication/send-csv-messages'
        title='Comunicação'
        fontIcon='bi-telephone-forward'
        bsTitle=' Comunicação'
        className='py-2'
        isMenuOpen={isMenuOpen}
      />

      <AsideMenuItem
        to='/category-tree/nicknames'
        title='Árvore de Categorias'
        fontIcon='bi-diagram-3'
        bsTitle='Árvore de Categorias'
        className='py-2'
        isMenuOpen={isMenuOpen}
      />

      {currentUser?.role === 'ROLE_MECANIZOU_ADMIN' && (
        <AsideMenuItem
          to='/dialer/upload'
          title='Discador'
          fontIcon='bi-telephone-outbound'
          bsTitle='Discador'
          className='py-2'
          isMenuOpen={isMenuOpen}
        />
      )}
      {OPS_OVERVIEW_ENABLED && (
        <AsideMenuItem
          to='/visao-operacional'
          title='Visão operacional'
          bsTitle='Visão operacional'
          fontIcon='bi-grid-3x3-gap-fill'
          className='py-2'
          isMenuOpen={isMenuOpen}
        />
      )}
      <div style={{height: '80px'}} />
    </>
  );
};
